import React from 'react';
import Seo from '../components/Seo';

function ViajesLiterarios() {
  return (
    <div className="page editorial-index">
      <Seo title="Viajes literarios" description="Librerías, ferias, rutas y ciudades vinculadas a autores y novelas." />
      <header className="editorial-index__header">
        <span className="eyebrow">Cuaderno de viaje</span>
        <h1>Viajes literarios</h1>
        <p className="page__intro">
          Librerías, rutas, cafés y lugares vinculados con escritores y novelas.
        </p>
      </header>
      <div className="editorial-empty" role="status">
        <span className="editorial-empty__ornament" aria-hidden="true">✦</span>
        <p className="editorial-empty__title">Nuevas historias están preparando su equipaje.</p>
        <p>Muy pronto encontrarás aquí destinos para viajar entre páginas.</p>
      </div>
    </div>
  );
}

export default ViajesLiterarios;
